import InputField from './InputField.component';
export type { InputFieldProps } from './InputField.component';

export default InputField;
